import $api from "../Api";
import ResponseChecker from "../Middlewares/ResponseChecker";
import { defaultMessages } from "../enums/responseMessages.js";
import Endpoints from "../Endpoints";

const check = (response) => ResponseChecker(defaultMessages, response);
export const GetAll = async (option) => check(await $api.get(Endpoints.PaymentTermRule.GetAll(option)));
export const Create = async (form) => check(await $api.post(Endpoints.PaymentTermRule.Create(), form));
export const Update = async (form, option) => check(await $api.put(Endpoints.PaymentTermRule.Update(option), form));
export const UpdateActive = async (form, option) => check(await $api.put(Endpoints.PaymentTermRule.UpdateActive(option), form));
export default { GetAll, Create, Update, UpdateActive };
